import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const dayKey = (d) => {
  const x = new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
};

export const DEFAULT_COLORS = { classes: "#90EE90", socials: "#3B1344", events: "#89CFF0" };

export const itemColor = (it, colorMap = DEFAULT_COLORS) => {
  if (it.type === "class") return colorMap.classes || DEFAULT_COLORS.classes;
  const key = it.category || "events";
  return colorMap[key] || colorMap.events || DEFAULT_COLORS.events;
};

export const textOn = (hex) => {
  const h = (hex || "").replace("#", "");
  if (h.length < 6) return "#fff";
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? "#0D0B14" : "#fff";
};

const WD = ["S", "M", "T", "W", "T", "F", "S"];

export default function CalendarGrid({ month, setMonth, itemsByDay, selectedKey, selectedKeys, onSelectDay, colorMap = DEFAULT_COLORS }) {
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const startPad = first.getDay();
  const daysInMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const todayKey = dayKey(new Date());

  const cells = [];
  for (let i = 0; i < startPad; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(month.getFullYear(), month.getMonth(), d));
  while (cells.length % 7 !== 0) cells.push(null);

  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-4">
      <div className="flex items-center justify-between mb-4">
        <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1, 1))} data-testid="cal-prev" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center active:scale-90 transition-transform"><ChevronLeft size={18} /></button>
        <p className="font-display text-lg font-semibold" data-testid="cal-month-label">{month.toLocaleDateString(undefined, { month: "long", year: "numeric" })}</p>
        <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1, 1))} data-testid="cal-next" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center active:scale-90 transition-transform"><ChevronRight size={18} /></button>
      </div>
      <div className="grid grid-cols-7 gap-1 mb-1">
        {WD.map((w, i) => <div key={`wd-${i}`} className="text-center text-[10px] text-[#A19DB0] py-1">{w}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((c, i) => {
          if (!c) return <div key={`pad-${i}`} />;
          const k = dayKey(c);
          const items = itemsByDay[k] || [];
          const isToday = k === todayKey;
          const isSel = selectedKeys ? selectedKeys.includes(k) : k === selectedKey;
          return (
            <button key={k} onClick={() => onSelectDay(c)} data-testid={`cal-day-${k}`}
              className={`aspect-square rounded-xl flex flex-col items-center justify-start pt-1.5 gap-1 border transition-colors ${isSel ? "bg-[#D4AF37] text-black border-[#D4AF37]" : isToday ? "border-[#D4AF37]/50 bg-white/5" : "border-transparent hover:bg-white/5"}`}>
              <span className={`text-xs ${isSel ? "font-bold" : ""}`}>{c.getDate()}</span>
              <div className="flex gap-0.5 flex-wrap justify-center px-1">
                {items.slice(0, 3).map((it, idx) => (
                  <span key={`${k}-dot-${idx}`} className="w-1.5 h-1.5 rounded-full" style={{ background: isSel ? "#000" : itemColor(it, colorMap) }} />
                ))}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
